import {
  OnsiteUpsellNamedSlotList,
  OnsiteUpsellProductSlotList,
} from "./components";

// Slots a template may reference; everything else in the markup is literal HTML.
export const OnsiteUpsellTemplateSlotWhitelist = [
  ...OnsiteUpsellProductSlotList,
  ...OnsiteUpsellNamedSlotList,
] as const;

const SLOT_TOKEN_PATTERN = /\{\{\s*([^{}]+?)\s*\}\}/g;

export function extractTemplateSlots(template: string): string[] {
  return Array.from(template.matchAll(SLOT_TOKEN_PATTERN), (match) => match[1]);
}

export function findUnknownTemplateSlots(template: string): string[] {
  const whitelist = new Set<string>(OnsiteUpsellTemplateSlotWhitelist);
  return Array.from(
    new Set(
      extractTemplateSlots(template)
        // ignore handlebars block open/close (e.g. `#each products`, `/each`)
        .filter((slot) => !slot.startsWith("#") && !slot.startsWith("/"))
        .filter((slot) => !whitelist.has(slot))
    )
  );
}

// Every whitelisted slot must stay in the template: each degrades to empty (and
// hides via `:empty`) when it has no value, so keeping them is always safe, while
// dropping one silently removes that element — e.g. losing `product.compareAtPrice`
// takes the comparison price with it. Returns the whitelisted slots not present.
export function findMissingTemplateSlots(template: string): string[] {
  const present = new Set(extractTemplateSlots(template));
  return OnsiteUpsellTemplateSlotWhitelist.filter((slot) => !present.has(slot));
}
